import * as Repositories from '../../repositories/repositories'
import * as Model from '../../models/models';
import {PaymentSearchViewModel} from './paymentSearch.viewmodel';
import {PaymentSearchResult} from './paymentSearch.viewmodel';
import * as _ from 'lodash';


export class PaymentSearchGateway {

    static $inject = [ 'policyholderRepository','paymentRepository' ];
    constructor(
        private policyholderRepository: Repositories.PolicyholderRepository,
        private paymentRepository: Repositories.PaymentRepository
    ) { }

    public loadPaymentSearchViewModel = (paymentSearchViewModel: PaymentSearchViewModel): ng.IPromise<PaymentSearchViewModel> => {

        
        if(paymentSearchViewModel.paymentSearchCriteria.organizationName) 
        {
           return this.loadSearchResultsWithOrganizationName(paymentSearchViewModel);
        }
        else
        {
         return this.loadSearchResultsWithOutOrganizationName(paymentSearchViewModel);
        }

    }

    private loadSearchResultsWithOrganizationName = (paymentSearchViewModel: PaymentSearchViewModel): ng.IPromise<PaymentSearchViewModel> => {
        
        return this.getPolicyholderByOrganizationName(paymentSearchViewModel.paymentSearchCriteria.organizationName)
            .then((policyholders: Array<Model.IPolicyholder>) => {

                paymentSearchViewModel.policyholders = policyholders;
                paymentSearchViewModel.paymentSearchCriteria.policyholderIds = _.map(policyholders,'id') as Array<string>;
                return this.getPaymentSummaries(paymentSearchViewModel.paymentSearchCriteria);
            })
            .then((paymentSummaries: Array<Model.IPaymentSummary>) => {
                paymentSearchViewModel.paymentSummaries = paymentSummaries;
                return this.createSearchResults(paymentSearchViewModel);
            })
            

    }

    private loadSearchResultsWithOutOrganizationName = (paymentSearchViewModel: PaymentSearchViewModel): ng.IPromise<PaymentSearchViewModel> => {

        
        return this.getPaymentSummaries(paymentSearchViewModel.paymentSearchCriteria)
                .then((paymentSummaries:Array<Model.IPaymentSummary>)=>{

                    paymentSearchViewModel.paymentSummaries = paymentSummaries

                    let policyholderSearchCriteria = new Model.PolicyholderSearchCriteria();
                    policyholderSearchCriteria.policyholderIds =  _.map(paymentSummaries,'systemReferenceNumber')as Array<string>;

                    return this.getPolicyholders(policyholderSearchCriteria);
                })
                .then((policyholders:Array<Model.IPolicyholder>)=>{
                    paymentSearchViewModel.policyholders = policyholders;
                    return this.createSearchResults(paymentSearchViewModel);
                });
    }
    
    private getPolicyholderByOrganizationName = (organizationName:string): ng.IPromise<Array<Model.IPolicyholder>> => {
        return this.policyholderRepository.getPolicyholdersByOrganziationName(organizationName)
            .then((policyholders: Array<Model.IPolicyholder>) => {
                return policyholders;
            });
    }

    private getPolicyholders = (searchCriteria: Model.IPolicyholderSearchCriteria): ng.IPromise<Array<Model.IPolicyholder>> => {
        return this.policyholderRepository.PolicyholderSearch(searchCriteria)
            .then((policyholders: Array<Model.IPolicyholder>) => {
                return policyholders;
            });
    }

    private getPaymentSummaries = (searchCriteria: Model.IPaymentSummarySearchCriteria): ng.IPromise<Array<Model.IPaymentSummary>> => {
        
        searchCriteria.eventTimeFromLocal = this.convertUtcTimeToLocalTime(searchCriteria.eventTimeFromUtc);
        searchCriteria.eventTimeToLocal = this.convertUtcTimeToLocalTime(searchCriteria.eventTimeToUtc);

        return this.paymentRepository.paymentSummarySearchAsync(searchCriteria)
        .then((paymentSummary: Array<Model.IPaymentSummary>) => {
            return paymentSummary;
        });
    }

    private createSearchResults = (searchViewModel: PaymentSearchViewModel): PaymentSearchViewModel => {

        let searchResults = new Array<PaymentSearchResult>();

        _.forEach(searchViewModel.paymentSummaries, (paymentSummary:Model.IPaymentSummary) => {
            let searchResult = new PaymentSearchResult();
            searchResult.paymentId = paymentSummary.paymentId;
            searchResult.paymentAmount = paymentSummary.paymentAmount;
            searchResult.requestedAt = paymentSummary.requestedAt;
            searchResult.decisionType = paymentSummary.decisionType;
            searchResult.requestOriginType = paymentSummary.requestOriginType;
            searchResult.reasonCode = paymentSummary.reasonCode;
            searchResult.systemReferenceNumber = paymentSummary.systemReferenceNumber;
            searchResult.paymentType = paymentSummary.paymentType;

            if(paymentSummary.cardNumber)
            {
                searchResult.paymentAcct = paymentSummary.cardNumber;
            }
            if(paymentSummary.echeckAccountNumber)
            {
                searchResult.paymentAcct = paymentSummary.echeckAccountNumber;
            }
           
            _.forEach(searchViewModel.policyholders, (policyholder:Model.IPolicyholder) => {
                if(paymentSummary.systemReferenceNumber === policyholder.id){
                    searchResult.organizationName = policyholder.name;
                    searchResult.billingAccountNumber = policyholder.billingAccountNumber;
                }
            });

            searchResults.push(searchResult);
            
        });

        searchViewModel.searchResults = searchResults;

        return searchViewModel;

    }

    private convertUtcTimeToLocalTime = (date: Date): Date => {
        return date != null ? new Date(date.getTime() + (60000 * date.getTimezoneOffset())) : null;
    }

}